import { useNavigate } from 'react-router';
import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSimulationsQuery } from '../../network/queries';
import { Loader } from '../common';

function ScenarioCard({ scenario }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isLoading: isLoadingSimulations, data: simulations } =
    useSimulationsQuery(scenario.id);

  const hasSimulations =
    !isLoadingSimulations && simulations && simulations.length;

  return (
    <Card
      sx={{
        height: '100%',
      }}
    >
      {isLoadingSimulations ? (
        <Loader />
      ) : (
        <>
          <CardContent>
            <Typography variant="h6" color="primary">
              {scenario.name}
            </Typography>
            <Typography>{scenario.description}</Typography>
          </CardContent>
          <CardActions>
            {!hasSimulations && (
              <Button
                onClick={() => navigate(`../scenarios/${scenario.id}/edit`)}
              >
                {t('common.edit')}
              </Button>
            )}
            <Button onClick={() => navigate(`../scenarios/${scenario.id}`)}>
              {t('common.view')}
            </Button>
          </CardActions>
        </>
      )}
    </Card>
  );
}

export default ScenarioCard;
